<template>
  <AccordionCard
    v-show="!cardSelected || (isEditing && isCollapsed)"
    :hideChevrons="true"
    :isCollapsed="isCollapsed">
    <template slot="title">
      Landing page
      <span
        class="kt-badge kt-badge--danger kt-badge--inline kt-badge--pill kt-badge--rounded ml-3"
        v-tooltip.right-end="{ content: 'Software in the beta phase will generally have many more bugs in it than completed software, speed or performance issues, and may still cause crashes or data loss. Please not use for commercial purpose.', offset: 5 }"
        v-if="false">Beta
      </span>
    </template>
    <template slot="buttons">
      <a
        class="btn btn-md btn-outline-hover-secondary kt-label-font-color-2--off text-danger"
        :class="{ 'disabled': !isCompletedQuote }"
        :href="landingPage"
        target="_blank"
        v-if="!isCollapsed">
        <font-awesome-icon :icon="['fas', 'globe']" class="mr-1" /> Open
      </a>
      <button
        class="btn btn-outline-brand btn-outline-danger btn-elevate btn-circle btn-icon btn-sm"
        :disabled="isLoading || isEditing || !isCompletedQuote"
        @click="emitSelectAccordionCard('landing-page')"
        v-if="!isCollapsed">
        <font-awesome-icon :icon="['fas', 'pen']" />
      </button>
      <button
        class="btn btn-md btn-outline-hover-secondary kt-label-font-color-2"
        :disabled="isSaving"
        @click="cancel"
        v-if="isCollapsed">
        <font-awesome-icon :icon="['fas', 'times']" class="mr-1" /> Cancel
      </button>
      <button
        class="btn btn-sm btn-wide btn-primary"
        :disabled="isSaving"
        @click="save"
        v-if="isCollapsed">
        <font-awesome-icon :icon="['fas', 'check']" class="mr-1" v-if="!isSaving" />
        <font-awesome-icon :icon="['fas', 'spinner']" spin class="mr-1" v-if="isSaving" /> Done
      </button>
    </template>
    <div class="container">
      <div class="row mb-5">
        <div class="form-group col-md-2">
          <label class="labelTitle">Select your template</label>
        </div>
        <div class="col-md-10">
          <ImagePicker
            :isDuplicated="false"
            :imageUrl="getTemplateImageUrl"
            :isEditing="true"
            :total="totalImages"
            :images="images"
            :countries="countries"
            :isSearching="isImagePickerSearching"
            :defaultParams="defaultImagePickerParams"
            :limitMinOfSelectedImages="limitMinOfSelectedImagesTemplate"
            :limitMaxOfSelectedImages="limitMaxOfSelectedImagesTemplate"
            :labelSearch="`Select ${limitMaxOfSelectedImagesTemplate} image(s)`"
            :labelButton="`Select ${limitMaxOfSelectedImagesTemplate} image(s)`"
            @onSearch="onImagePickerSearch"
            @onSelectImage="onImagePickerSelectTemplateImages"
            style="width: 150px;height: auto;" />
            <div class="text-danger my-3" v-if="hasErrorsTemplate">This field is required and It needs to select {{ limitMaxOfSelectedImagesTemplate }} image(s).</div>
        </div>
      </div>
    </div>
  </AccordionCard>
</template>

<script>
import { mapGetters } from 'vuex'
import NProgress from 'nprogress'

import AccordionCard from '@/components/_shared/accordion/AccordionCard.vue'
import ImagePicker from '@/components/_shared/image-picker/ImagePicker.vue'

export default {
  name: 'TabShareLandingPage',
  data () {
    return {
      pageUrl: process.env.VUE_APP_LANDING_PAGE_URL,
      isLoading: false,
      templateImagesSelected: [],
      images: [],
      totalImages: 0,
      isImagePickerSearching: false,
      limitMinOfSelectedImagesTemplate: 3,
      limitMaxOfSelectedImagesTemplate: 3,
      isSaving: false,
      hasErrorsTemplate: false
    }
  },
  components: {
    AccordionCard,
    ImagePicker
  },
  computed: {
    ...mapGetters({
      'countries': 'location/countries'
    }),
    defaultImagePickerParams () {
      return {
        limit: 21,
        offset: 0,
        w: 150,
        h: 150,
        country: '',
        city: ''
      }
    },
    getTemplateImageUrl () {
      if (
        this.templateImagesSelected &&
        Array.isArray(this.templateImagesSelected) &&
        this.templateImagesSelected.length > 1) {
        return this.templateImagesSelected[0].url
      }
      if (this.data &&
          Array.isArray(this.data.background) &&
          this.data.background.length === this.limitMaxOfSelectedImagesTemplate) {
        return this.data.background
      }
      return ''
    },
    landingPage () {
      const uuid = this.$route.params.privateId
      if (this.isCompletedQuote) {
        return `${this.pageUrl}/landingpage/${uuid}`
      }
      return ''
    }
  },
  props: {
    cardSelected: {
      type: String,
      required: true
    },
    isCollapsed: {
      type: Boolean,
      required: true
    },
    isEditing: {
      type: Boolean,
      required: true
    },
    isCompletedQuote: {
      type: Boolean,
      default: false
    },
    data: {
      type: [Array, Object],
      required: false
    }
  },
  methods: {
    emitSelectAccordionCard (cardName) {
      this.$emit('onSelect', cardName)
    },
    onImagePickerSearch (params) {
      if (params.country === '' && params.city === '') {
        this.isImagePickerSearching = false
        this.totalImages = 0
        this.images = []
        return false
      }
      this.isImagePickerSearching = true
      this.$store.dispatch('asset/getAssets', params)
        .then(response => {
          this.images = response.asset // Array images
          this.totalImages = response.total
          this.isImagePickerSearching = false
        })
        .catch(error => {
          console.log(error)
          this.isImagePickerSearching = false
          this.totalImages = 0
          this.images = []
        })
    },
    onImagePickerSelectTemplateImages (imagesSelected) {
      this.templateImagesSelected = imagesSelected
    },
    cancel () {
      this.templateImagesSelected = null
      this.emitSelectAccordionCard('')
    },
    save () {
      if (!this.templateImagesSelected) {
        if (this.data &&
          Array.isArray(this.data.background) &&
          this.data.background.length === this.limitMaxOfSelectedImagesTemplate) {
          this.templateImagesSelected = this.data.background
        }
      }

      let imagesTemplate = null

      imagesTemplate = this.templateImagesSelected.map(i => {
        if (i.assetId) {
          return { id: null, asset_id: i.assetId }
        }
        if (i.asset_id) {
          return { id: null, asset_id: i.asset_id }
        }
        return { id: null }
      })

      const payload = {
        background: imagesTemplate,
        dataRootKey: 'consumer_section'
      }

      this.$store.commit('opportunity/TEMP_SAVE_LANDING_PAGE_OR_GUEST_DOCUMENTATION', payload)

      this.isSaving = true

      this.$store
        .dispatch('opportunity/saveOpportunity')
        .then((response) => {
          if (response.data && response.data.uuidOpportunity) {
            const privateId = response.data.uuidOpportunity
            this.$notification.success(response.message)
            this.$notification.warning('Now try to open the landing page with its new settings.', 5000)
            this.emitSelectAccordionCard('')
            this.templateImagesSelected = null
            this.$store
              .dispatch('opportunity/getOpportunity', privateId)
              .then((response) => {
                this.isSaving = false
                NProgress.done()
              })
              .catch(error => {
                if (error.response && error.response.status > 400) { // 401 || 403
                  // this.$store.dispatch('auth/removeToken')
                }
              })
          } else {
            this.isSaving = false
            NProgress.done()
            this.$notification.error(response.message)
          }
        })
        .catch(error => {
          console.log(error)
          this.isSaving = false
          NProgress.done()
        })
    }
  }
}
</script>
